import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../services/commons-service.service";

export class BringozCustomMultiSelectListComponent implements IController {
  values: any [];
  options: any;
  optionsWrapper?: { list?: any[], propertyRef: string };
  ngPlaceholder: any;
  isOrderedOptions: boolean;
  optionsPrefix: string;
  excludeIds: string[];
  onChange: Function;

  private selectedKeys: any;
  private queryString: any;
  public optionsCopy: any[];
  public isSelectAll: boolean;
  public excludedMap: any;

  constructor(private commonsService: CommonsService) {
  }

  $onInit() {
    // this.optionsCopy = [...this.options];
    this.optionsCopy = this.optionsWrapper ?
      _.map(this.optionsWrapper.list, (o) => {
        return {name: _.get(o, this.optionsWrapper.propertyRef), id: o.id}
      }) :
      _.map(this.options, (o) => {
        return {name: o, id: o}
      });

    if (this.isOrderedOptions) {
      this.orderOptions();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.values) {
      this.selectedKeys = [];
      _.forEach(this.values, (v) => {
        this.selectedKeys[v] = true;
      })
      if (this.isOrderedOptions) {
        this.orderOptions();
      }
    }

    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }

  }

  onToggle(option, isSelected) {
    this.onChange({
      values: isSelected ? _.concat(this.values, [option.id]) :
        _.filter(this.values, (v) => {
          return v !== option.id;
        })
    });
  }

  onReset() {
    this.onChange({values: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

  onToggleSelectAll() {
    if (this.isSelectAll) {
      this.onReset();
    } else {
      this.onChange({values: this.optionsCopy?.map(o => o.id) || []});
    }
  }


  isAllSelected() {
    this.isSelectAll = this.commonsService.checkIfArraysMatch(this.optionsCopy.map(o => o.id), this.values);
    return this.isSelectAll;
  }

  private orderOptions() {
    if (this.values.length) {
      const unselectedOptions = this.optionsCopy?.filter((o) => {
        return !this.values.includes(o.id);
      });
      const selectedOptions = this.optionsCopy?.filter((o) => {
        return this.values.includes(o.id);
      });
      this.optionsCopy = [...selectedOptions, ...unselectedOptions];
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozCustomMultiSelectList', {
    bindings: {
      values: '<',
      options: '<?',
      optionsWrapper: '<?',
      isOrderedOptions: '<',
      excludeIds: '<?',
      ngPlaceholder: '@?',
      onChange: '&',
      optionsPrefix: '@?'
    },
    template: require('./bringoz-custom-multi-select-list.html').default,
    controller: BringozCustomMultiSelectListComponent
  });
